import React from "react";
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom"; 

import InstantChecksImg from '../assets/icons/instantChecksImg.png';
import BackgroundChecksImg from '../assets/icons/backgroundChecksImg.png';
import DueDiligenceImg from '../assets/icons/dueDiligenceImg.png'; 
import { PlatformInsightsDescription, PlatformInsightsLeftContent, PlatformInsightsRightContent, PlatformInsightsRightImageWrapper, PlatformInsightsSectionContainer, PlatformInsightsSubTitle, PlatformInsightsTitle } from "../assets/styles/CommonStyles";



const PlatformInsights = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isInstantChecks = location.pathname.includes("instant-checks");
  const isBackgroundChecks = location.pathname.includes("background-checks");
  const isDueDiligence = location.pathname.includes("due-diligence");
  console.log("isDueDiligence", isDueDiligence);

  console.log("Current URL:", location.pathname); 
  console.log("isDueDiligence", isDueDiligence);

  const instantChecksData = {
    title: "Instant Checks",
    subtitle: "Instant, Reliable Checks: Verified in Seconds.",
    description: "Effortless verifications at your fingertips.<br />Speed up your onboarding, minimize errors, and ensure <br /> compliance—all in one platform.",
    imageSrc: InstantChecksImg,
    buttonText: "Get Demo"
  };

  const backgroundChecksData = {
    title: "Background Checks",
    subtitle: "Thorough, Detailed Validation at Your Command",
    description: "Verify employee histories, criminal records, and more—ensuring your business is always in compliance.",
    imageSrc: BackgroundChecksImg,
    buttonText: "Get Demo"
  };

  const dueDiligenceData = {
    title: "Due Diligence",
    subtitle: "Detailed Analysis - Dive Deeper into Every Aspect.",
    description: "Make confident decisions with our advanced due diligence platform. From financial insights to compliance assurance, we offer comprehensive tools to evaluate, analyze, and act with clarity.",
    imageSrc: DueDiligenceImg, 
    buttonText: "Get Demo"
  };

  const content = isInstantChecks
    ? instantChecksData
    : isBackgroundChecks
    ? backgroundChecksData
    : isDueDiligence
    ? dueDiligenceData
    : instantChecksData;

  return (
    <PlatformInsightsSectionContainer isDueDiligence={isDueDiligence}>
      <PlatformInsightsLeftContent isDueDiligence={isDueDiligence}>
        <PlatformInsightsTitle>{content.title}</PlatformInsightsTitle>
        <PlatformInsightsSubTitle>{content.subtitle}</PlatformInsightsSubTitle>
        <PlatformInsightsDescription dangerouslySetInnerHTML={{ __html: content.description }}/>

        <Button className="custom-button" variant="contained" onClick={() => navigate("/contact-us")}>{content.buttonText}</Button>
      </PlatformInsightsLeftContent>

      <PlatformInsightsRightContent>
        <PlatformInsightsRightImageWrapper src={content.imageSrc} alt={content.title} isDueDiligence={isDueDiligence}/>
      </PlatformInsightsRightContent>
    </PlatformInsightsSectionContainer>
  );
};

export default PlatformInsights;
